<template>
  <div class="notifications-wrapper">
    <div class="container">
      <div class="card">
        <h2>Gestion des notifications</h2>
        <div class="card-section">
          <h4>Notification par e-mail</h4>
          <p class="muted">
            Duis aute irure dolor in reprehenderit in voluptate velit. Excepteur
            sint occaecat cupidatat non proident, sunt in culpa qui officia.
          </p>
          <div class="toggle-container">
            <div class="input-wrapper input-wrapper-toggle inline">
              <div class="toggle">
                <input type="checkbox" />
                <label></label>
              </div>
              <div class="content">
                <p class="bold">Consectetur adipiscing elit</p>
                <p class="muted">Sed do eiusmod tempor incididunt ut labore</p>
              </div>
            </div>
            <div class="input-wrapper input-wrapper-toggle inline">
              <div class="toggle">
                <input type="checkbox" />
                <label></label>
              </div>
              <div class="content">
                <p class="bold">Consectetur adipiscing elit</p>
                <p class="muted">Sed do eiusmod tempor incididunt ut labore</p>
              </div>
            </div>
            <div class="input-wrapper input-wrapper-toggle inline">
              <div class="toggle">
                <input type="checkbox" />
                <label></label>
              </div>
              <div class="content">
                <p class="bold">Consectetur adipiscing elit</p>
                <p class="muted">Sed do eiusmod tempor incididunt ut labore</p>
              </div>
            </div>
          </div>
        </div>
        <div class="card-section">
          <h4>Notification par SMS</h4>
          <p class="muted">
            Duis aute irure dolor in reprehenderit in voluptate velit. Excepteur
            sint occaecat cupidatat non proident, sunt in culpa qui officia.
          </p>
          <div class="toggle-container">
            <div class="input-wrapper input-wrapper-toggle inline">
              <div class="toggle">
                <input type="checkbox" />
                <label></label>
              </div>
              <div class="content">
                <p class="bold">Consectetur adipiscing elit</p>
                <p class="muted">Sed do eiusmod tempor incididunt ut labore</p>
              </div>
            </div>
            <div class="input-wrapper input-wrapper-toggle inline">
              <div class="toggle">
                <input type="checkbox" />
                <label></label>
              </div>
              <div class="content">
                <p class="bold">Consectetur adipiscing elit</p>
                <p class="muted">Sed do eiusmod tempor incididunt ut labore</p>
              </div>
            </div>
            <div class="input-wrapper input-wrapper-toggle inline">
              <div class="toggle">
                <input type="checkbox" />
                <label></label>
              </div>
              <div class="content">
                <p class="bold">Consectetur adipiscing elit</p>
                <p class="muted">Sed do eiusmod tempor incididunt ut labore</p>
              </div>
            </div>
          </div>
        </div>
        <div class="card-section">
          <h4>Notification SaaS</h4>
          <p class="muted">
            Duis aute irure dolor in reprehenderit in voluptate velit. Excepteur
            sint occaecat cupidatat non proident, sunt in culpa qui officia.
          </p>
          <div class="toggle-container">
            <div class="input-wrapper input-wrapper-toggle inline">
              <div class="toggle">
                <input type="checkbox" />
                <label></label>
              </div>
              <div class="content">
                <p class="bold">Consectetur adipiscing elit</p>
                <p class="muted">Sed do eiusmod tempor incididunt ut labore</p>
              </div>
            </div>
            <div class="input-wrapper input-wrapper-toggle inline">
              <div class="toggle">
                <input type="checkbox" />
                <label></label>
              </div>
              <div class="content">
                <p class="bold">Consectetur adipiscing elit</p>
                <p class="muted">Sed do eiusmod tempor incididunt ut labore</p>
              </div>
            </div>
            <div class="input-wrapper input-wrapper-toggle inline">
              <div class="toggle">
                <input type="checkbox" />
                <label></label>
              </div>
              <div class="content">
                <p class="bold">Consectetur adipiscing elit</p>
                <p class="muted">Sed do eiusmod tempor incididunt ut labore</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
